const {
  site = "ordbogen",
  language = "en",
  isMobile = false,
  isBetaSite = false,
  isInternalSite = false,
  isAuthenticated = false,
  isOrdbogenAccount = false,
  openingHours = {
    open: "",
    close: "",
    closeFriday: ""
  },
  supportTemporarilyClosed = {
    chat: false,
    phone: false
  }
} = window.lemue;

export const config = {
  app: {
    isProduction: import.meta.env.PROD,
    site,
    language,
    isMobile,
    isBetaSite,
    isInternalSite,
    openingHours,
    supportTemporarilyClosed,
    matomo: {
      host: import.meta.env.VITE_MATOMO_HOST,
      siteId: import.meta.env.VITE_MATOMO_SITE_ID
    },
    sentry: {
      dsn: import.meta.env.VITE_APP_SENTRY_DSN
    }
  },
  user: {
    isAuthenticated,
    isOrdbogenAccount
  },
  api: {
    pathPrefix: `/${language}/api/web`
  },
  ordbogen: {
    email: {
      support: "support@ordbogen.com",
      business: "business@ordbogen.com"
    },
    phone: {
      display: "+45 6612 6000",
      number: "+4566126000"
    }
  },
  externalLinks: {
    browserExtension: {
      edge: "https://microsoftedge.microsoft.com/addons/detail/ordbogencom/gpakbjoiblpibgfjdehfjnhejkoghbbn",
      chrome: "https://chromewebstore.google.com/detail/ordbogencom/lliifkldpflpgmjkpdoolkfpafbdbkoh",
      fireFox: "https://addons.mozilla.org/en-US/firefox/addon/ordbogen-com/"
    },
    mobileApp: {
      android: "https://play.google.com/store/apps/details?id=com.ordbogen",
      ios: "https://apps.apple.com/{country}/app/id409803876?l={language}"
    },
    op5: {
      windows: "https://apps.microsoft.com/detail/9mwjch57dxvg",
      mac: "https://apps.apple.com/{country}/app/ordbogsprogrammet-5/id1599705846?l={language}",
      msi: "https://dku19m04pehid.cloudfront.net/op5.msi"
    }
  }
};
